import { useCrmLevelSyncStore } from '~/stores/crm-level-sync';

// Gatilho da denúncia de divergência de nível CRM (stores/crm-level-sync.ts).
//
// Vive num plugin pelo mesmo motivo do player-profile.client.ts: a detecção não
// pertence a tela nenhuma — os dois lados da comparação chegam por caminhos
// assíncronos independentes (o /players/me pelo plugin de sessão, o nível da
// Smartico quando o SDK termina o identify), em qualquer ordem, com o jogador
// em qualquer rota.
//
// O watcher pode disparar quantas vezes for: quem garante "no máximo uma
// chamada por divergência detectada" é a store (assinatura por par de slugs),
// não a frequência daqui. Por isso não há debounce no watch — o freio de
// verdade é idempotência, que segura inclusive render/polling.
export default defineNuxtPlugin(() => {
  const syncStore = useCrmLevelSyncStore();
  const { isDiverged } = storeToRefs(syncStore);

  const { userId } = useUserData();

  // Disparar e esquecer, DE PROPÓSITO: a chamada não é aguardada aqui e nada no
  // app depende dela — a rota só avisa o core, não corrige nada e não devolve
  // nada pra tela. Se ela demorar, falhar ou nunca responder (rede, 503,
  // Smartico fora do ar), o jogador não fica sabendo e o fluxo dele segue igual.
  // A promise solta é segura porque `syncIfDiverged` engole toda recusa: ela
  // nunca rejeita.
  watch(
    isDiverged,
    (diverged) => {
      if (diverged) syncStore.syncIfDiverged();
    },
    { immediate: true },
  );

  // Troca de conta / logout: o histórico de tentativa era do jogador anterior.
  watch(userId, (id, previousId) => {
    if (previousId && previousId !== id) syncStore.reset();
  });
});
